<section class="tile p-0 d-flex flex-column">
    <div
        class="d-flex align-items-center justify-content-center image-area"
        [class.rounded-bottom-corners]="!shouldShowContentArea()"
        [style.background-image]="'url(' + imageSrc + ')'"
    >
        <a
            *ngIf="videoUrl"
            class="col p-0 play-button"
            [href]="videoUrl"
            target="_blank"
            [title]="title || ('MY_WORKSPACE.MY_ACTIVITIES.WATCH_VIDEO' | translate)"
        >
            <ca-icon name="play" size="l" class="watch-video-button ca-color-on-background-on-surface"></ca-icon>
        </a>
    </div>
    <div class="content-area p-3 d-flex flex-column justify-content-between overflow-hidden" *ngIf="shouldShowContentArea()">
        <div class="text-section">
            <!-- Title with Video Link (if available) -->
            <h4 *ngIf="videoUrl">
                <a class="title font-m mb-2" [href]="videoUrl" target="_blank" [title]="'MY_WORKSPACE.MY_ACTIVITIES.WATCH_VIDEO' | translate">
                    {{ title }}
                </a>
            </h4>
            <!-- Title with CTA link (if video is not provided) -->
            <h4 *ngIf="!videoUrl && routeLink">
                <a class="title mb-2" (click)="openLink()" target="_blank" [title]="buttonText">
                    {{ title }}
                </a>
            </h4>
            <!-- Title without link -->
            <h4 *ngIf="!videoUrl && !routeLink" class="title mb-2">{{ title }}</h4>
            <div *ngIf="description" class="description font-sm my-2">{{ description }}</div>
        </div>
        <ca-call-to-action *ngIf="routeLink" [innerText]="buttonText" [className]="callToActionClass" [openInNewPage]="openInNewPage" [routeLink]="routeLink">
        </ca-call-to-action>
    </div>
</section>
